<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 class="fronttitle paired">Contents</h1>
<hr/>
<p class="toc sub"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="toc sub"><a href="#/contents">Contents</a></p>
<p class="toc sub"><a href="#/front01">Copyright</a></p>
<p class="toc sub"><a href="#/front02">Translator’s Note</a></p>
<p class="toc"><a href="#/c01">Santiago de Compostela</a></p>
<p class="toc"><span href="#/c02" title="Link target outside of Sample">Circular Therapy</span></p>
<p class="toc"><span href="#/c03" title="Link target outside of Sample">The Slumbering Soldiers</span></p>
<p class="toc"><span href="#/c04" title="Link target outside of Sample">In Our Synagogue</span></p>
<p class="toc"><span href="#/c05" title="Link target outside of Sample">Confession</span></p>
<p class="toc"><span href="#/c06" title="Link target outside of Sample">Putting the Old House in Order</span></p>
<p class="toc"><span href="#/c07" title="Link target outside of Sample">Virtual Mapping of the Heart</span></p>
<p class="toc"><span href="#/c08" title="Link target outside of Sample">Supper with Your Former Screenwriter</span></p>
<p class="toc"><span href="#/c09" title="Link target outside of Sample">Roman Charity</span></p>
<p class="toc sub"><span href="#/back01" title="Link target outside of Sample">Sample Chapter from FRIENDLY FIRE</span></p>
<p class="toc sub"><span href="#/back02" title="Link target outside of Sample">Buy the Book</span></p>
<p class="toc sub"><span href="#/back03" title="Link target outside of Sample">Read More from A. B. Yehoshua</span></p>
<p class="toc sub"><span href="#/back04" title="Link target outside of Sample">About the Author</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?3083592b